import { FrameBody, Wait } from "@npd-ng/adp-benchmark"
import { Content } from "../types/Content";
import React from "react";
import { useIPCBridge } from "../hooks/useIPCBridge";
import { useStateContext } from "../hooks/useStateContext";
import { checkNetworkState } from "../hooks/useNetworkService";
import { actions } from "../state";
const logPrefix = "[ADPClient][RedirectionView]"
export default function RedirectionView(){
  const { state, dispatch } = useStateContext();
  const content= state.staticContent as Content;
  const notifications = content.notifications;
  const {saveADPChromeAppState,startAssessment} = useIPCBridge(dispatch,state);
  let baseURI = state.sessionState.selectedAssessmentMode === "online" ? window.location.origin : window.location.origin;
  if(baseURI.includes("localhost")) baseURI = 'https://enaep.dev24.npdng.org'
  const url = `${baseURI}/login/index.html?adpLaunchId=${state.appState.appLaunchId}&setupcode=${state.sessionState.schoolDetails?.setupCode}&deviceId=${state.deviceState.deviceId}&locale=${state.sessionState.schoolDetails?.isPR ? "es" :"en"}&version=${state.appState.releaseVersion}`;
  console.log(logPrefix,"redirecting to:", url);
  React.useEffect(() => {
    saveADPChromeAppState(state);
    startAssessment();
    setTimeout(()=>{
      const warning = checkNetworkState(state.sessionState.networkConnectionState,state.sessionState.selectedAssessmentMode);
      if(warning) {
          dispatch(actions.createWarningAction(warning));
          return;
      }
      window.location.replace(url);
    },2000);   
}, []);
    return (
       <div>
       <FrameBody> 
        <Wait subTitle={notifications.wait}/>
        </FrameBody>
       </div>
    )
}